import { ApiClient } from '@/services/ApiClient';
import { useService } from '@nzyme/vue-ioc/useService.js';
import { AuthStore } from '@sigma/client/auth/AuthStore.js';
import type { PatientProfile } from '@sigma/common/patient/PatientProfile.js';
import { ProfileGetEndpoint } from '@sigma/patient-api/profile/ProfileGetEndpoint.js';
import { ProfileUpdateEndpoint } from '@sigma/patient-api/profile/ProfileUpdateEndpoint.js';

export function useProfile() {
    const apiClient = useService(ApiClient);
    const authStore = useService(AuthStore);

    return {
        updateProfile,
        getProfile,
    };

    async function getProfile() {
        return await apiClient(ProfileGetEndpoint);
    }

    async function updateProfile(profile: PatientProfile) {
        await apiClient(ProfileUpdateEndpoint, {
            // TODO simplify once we switch to zod
            firstName: profile.firstName ?? '',
            lastName: profile.lastName ?? '',
            birthDate: profile.birthDate!,
            gender: profile.gender!,
            address: {
                country: profile.address.country!,
                city: profile.address.city!,
                street: profile.address.street!,
                postCode: profile.address.postCode!,
                state: profile.address.state ?? null,
            },
            data: profile.data,
        });

        await authStore.refreshAuth();
    }
}
